import { LoadingButton } from '@mui/lab';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, Button, CardContent, DialogTitle, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { CommonHelper } from 'src/utils/commonHelper';
import { useTranslation } from 'react-i18next';

const BlueskyAuthorizationModal = ({
  handleBlueskyConnect,
  handleClose,
  handleInputChange,
  identifier,
  password,
  isLoadingOn,
}) => {
  const { t: translate } = useTranslation();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography gutterBottom variant="h4">
          {translate('common.authorize')} {CommonHelper.GetAppName()}{' '}
          {translate('bluesky_common_integration.access_your_account')}
        </Typography>
        {(!isCustomDomain || isPortalAdmin) && (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=AznJUuHil4w', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>
          </Box>
        )}
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          backgroundColor: 'whitesmoke',
          padding: 3,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
            {translate('bluesky_common_integration.app_password_instruction')}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            • {translate('bluesky_common_integration.do_not_use_regular_password')}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            • {translate('bluesky_common_integration.generate_app_password_instruction')}
          </Typography>
        </Box>

        <CardContent sx={{ p: 0, color: 'grey.800' }}>
          <TextField
            name="identifier"
            value={identifier}
            label={translate('bluesky_common_integration.identifier_label')}
            placeholder="yourname.bsky.social"
            fullWidth
            margin="normal"
            onChange={handleInputChange}
          />

          <TextField
            name="password"
            value={password}
            label="App Password"
            type="password"
            fullWidth
            margin="normal"
            onChange={handleInputChange}
            helperText="This is your 8-character App Password (not your login password)"
          />
        </CardContent>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={handleBlueskyConnect}
        >
          {translate('common.connect')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default BlueskyAuthorizationModal;
